import { render, staticRenderFns } from "./MultipleTip.vue?vue&type=template&id=dbb5ad78&"
import script from "./MultipleTip.vue?vue&type=script&lang=js&"
export * from "./MultipleTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports